<div
    *ngIf="shouldShowIndicator()"
    class="offline-indicator"
    [class.offline]="isOffline()"
    [class.syncing]="isSyncing()"
    [class.online]="!isOffline() && !isSyncing() && !isReconnected()"
    [class.reconnected]="isReconnected()"
>
    <!-- Status Reconectado -->
    <div *ngIf="isReconnected()" class="indicator-content reconnected">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
        <span class="text">Reconectado</span>
    </div>

    <!-- Status Offline -->
    <div *ngIf="isOffline()" class="indicator-content offline">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
            <path
                d="M24 8.98C20.93 5.9 16.69 4 12 4S3.07 5.9 0 8.98L12 21 24 8.98zM2.92 9.07C5.51 7.08 8.67 6 12 6s6.49 1.08 9.08 3.07l-9.08 9.08-9.08-9.08z"
            />
        </svg>
        <span class="text">Offline</span>
        <span *ngIf="pendingActionsCount() > 0" class="pending-count">{{ pendingActionsCount() }}</span>
    </div>

    <!-- Status Sincronizando -->
    <div *ngIf="isSyncing()" class="indicator-content syncing">
        <svg class="icon spinning" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 4V2A10 10 0 0 0 2 12h2a8 8 0 0 1 8-8z" />
        </svg>
        <span class="text">Sincronizando</span>
        <div class="progress-bar">
            <div class="progress-fill" [style.width.%]="syncProgress()"></div>
        </div>
        <span class="progress-text">{{ syncProgress() | number: '1.0-0' }}%</span>
    </div>

    <!-- Status Online -->
    <div *ngIf="!isOffline() && !isSyncing()" class="indicator-content online">
        <svg class="icon" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
        </svg>
        <span class="text">Online</span>
    </div>

    <!-- Botão de ação -->
    <button *ngIf="showActionButton()" (click)="handleAction()" class="action-button" [disabled]="isSyncing()">
        {{ getActionButtonText() }}
    </button>
</div>
